import AcceptanceTermRepository from '@/shared/http/repositories/business/acceptanceterm.js'
import ExpenseRepository from '@/shared/http/repositories/business/expense.js'
import { loading } from '../utils/UIHelper'
import PermissionMixin from '@/store/module/permission/mixin'
// import { JWTService } from '@/shared/services/jwt'
import { mapGetters } from 'vuex'

export default {
  name: 'accessTermTravel',
  mixins: [PermissionMixin],
  data () {
    return {
      dataEnumAcess: [],
      dataEnumAcessDes: []
    }
  },
  mouted () {
  },
  computed: {
    ...mapGetters('auth', ['userInfo'])
  },
  methods: {
    getAllAcces () {
      loading.push()
      AcceptanceTermRepository.GeteAcessosClaimStatus()
        .then(Response => {
          this.dataEnumAcess = Response.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    verificarAcess (value) {
      if (this.dataEnumAcess.length <= 0) return false
      let acess = this.dataEnumAcess.find((Element) => parseInt(Element.value) === parseInt(value) && this.hasRole(Element.text))
      if (acess === null || acess === undefined) return false
      return true
    },
    getAllAccesDes () {
      loading.push()
      ExpenseRepository.GeteSituacaoAcesso()
        .then(Response => {
          loading.pop()
          this.dataEnumAcessDes = Response.data
        })
        .catch(Error => loading.pop())
    },
    verificarAcessDes (value, solicitanteid = null) {
      let contaid = this.userInfo.id
      if (this.dataEnumAcessDes.length <= 0) return false
      if (parseInt(value) === 0 && solicitanteid !== null) {
        if (solicitanteid === contaid) return true
      }
      let acess = this.dataEnumAcessDes.find((Element) => parseInt(Element.value) === parseInt(value) && this.hasRole(Element.text))
      if (acess === null || acess === undefined) return false
      return true
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/mixins/accessTermTravel.js